import { render, staticRenderFns } from "./recognizeList.vue?vue&type=template&id=5ac5beee&scoped=true"
import script from "./recognizeList.vue?vue&type=script&lang=js"
export * from "./recognizeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac5beee",
  null
  
)

export default component.exports